import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from 'services/baseQuery';

export const trainingsApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'trainingsApi',
  tagTypes: ['Training'],
  endpoints: (builder) => ({
    getListPassedTrainingByUser: builder.query({
      query: ({ params, id }) => ({
        url: `/users/${id}/passed_trainings`,
        method: 'GET',
        params,
      }),
    }),
    getNewestPassedTrainingByUser: builder.query({
      query: (id) => ({
        url: `/users/${id}/newest_passed_trainings`,
        method: 'GET',
      }),
    }),
    getRequiredTrainingProgressesByUser: builder.query({
      query: (params) => ({
        url: '/required_training_progresses',
        method: 'GET',
        params
      }),
    }),
    getTrainingProgresses: builder.query({
      query: (params) => ({
        url: '/training_progresses',
        method: 'GET',
        params: params
      }),
      providesTags: ['Training']
    }),
    getSystemRequiredTrainingProgresses: builder.query({
      query: (params) => ({
        url: '/training_progresses/system_required',
        method: 'GET',
        params: params
      }),
      providesTags: ['Training']
    }),
    updateTrainingReport: builder.mutation({
      query: (params) => ({
        url: `/training_progresses/${params.trainingReportId}`,
        method: 'PUT',
        body: params.body
      }),
      invalidatesTags: ['Training']

    }),
    batchUpdateTrainingReport: builder.mutation({
      query: (params) => ({
        url: '/training_progresses/batch_confirmation',
        method: 'POST',
        body: params.body
      })
    }),
    batchUpdateAllTrainingReport: builder.mutation({
      query: (params) => ({
        url: '/training_progresses/all_confirmation',
        method: 'POST',
        body: params.body
      })
    }),
    getDetailTrainingReport: builder.query({
      query: (trainingReportId) => ({
        url: `/training_progresses/${trainingReportId}`,
        method: 'GET',
      })
    }),
    getTrainingProgessesUnPage: builder.query({
      query: (params) => ({
        url: '/training_progresses_unpaging',
        method: 'GET',
        params: params
      })
    }),
    getTrainingCategoryList: builder.query({
      query: (params) => ({
        url: '/training_categories',
        method: 'GET',
        params: params
      })
    }),
    getDetailTrainingCategory: builder.query({
      query: (trainingCategoryId) => ({
        url: `/training_categories/${trainingCategoryId}`,
        method: 'GET',
      })
    }),
    getTrainingList: builder.query({
      query: (params) => ({
        url: `/training_categories/${params.categoryId}/trainings`,
        method: 'GET',
        params: params
      })
    }),
    getDetailTraining: builder.query({
      query: (params) => ({
        url: `/training_categories/${params.categoryId}/trainings/${params.trainingId}`,
        method: 'GET',
      })
    }),
    getTrainingCategoriesUnPage: builder.query({
      query: (params) => ({
        url: '/training_categories_unpaging',
        method: 'GET',
        params
      })
    }),
    getRequiredTrainings: builder.query({
      query: (params) => ({
        url: '/required_trainings',
        method: 'GET',
        params
      })
    }),
    batchCreateRequiredTraining: builder.mutation({
      query: ({ body }) => ({
        url: '/required_trainings/batch',
        method: 'POST',
        body: body
      })
    })
  }),
});

export const {
  useLazyGetListPassedTrainingByUserQuery,
  useGetTrainingProgressesQuery,
  useGetSystemRequiredTrainingProgressesQuery,
  useUpdateTrainingReportMutation,
  useBatchUpdateTrainingReportMutation,
  useBatchUpdateAllTrainingReportMutation,
  useGetDetailTrainingReportQuery,
  useGetTrainingCategoriesUnPageQuery,
  useLazyGetTrainingProgessesUnPageQuery,
  useLazyGetNewestPassedTrainingByUserQuery,
  useLazyGetRequiredTrainingProgressesByUserQuery,
  useGetTrainingCategoryListQuery,
  useGetDetailTrainingCategoryQuery,
  useGetTrainingListQuery,
  useGetDetailTrainingQuery,
  useBatchCreateRequiredTrainingMutation,
  useLazyGetRequiredTrainingsQuery
} = trainingsApi;
